<template>
  <div
    class="flex items-center justify-between w-full px-2 py-2 bg-white border-t border-b min-h-12">
    <div class="flex items-center justify-start flex-grow-0 gap-5">
      <button
        v-if="linkName || navigateToPreviousPage"
        @click="isModified ? emit('cancel', 'back') : onBack()"
        class="p-2 rounded-lg text-theme-600 hover:bg-theme-100">
        <IconArrowLeft />
      </button>
      <p class="font-semibold uppercase text-md">{{ title }}</p>
      <div class="flex space-x-1">
        <BaseButton
          v-if="mode === 'view' && isEditActive"
          @click="emit('editMode')"
          size="xs"
          outline
          color="light"
          class="gap-2 capitalize">
          <IconPencilSquare class="size-3" /> {{ $t('common.actions.edit') }}
        </BaseButton>
        <BaseControlsButtonIcon
          v-if="!hideLayoutOptions"
          @button-clicked="emit('horizontalLayout', true)"
          :tooltip-text="$t('common.tooltip.horizontalLayout')"
          :active="isHorizontalLayout">
          <IconLayoutHorizontal class="size-4" />
        </BaseControlsButtonIcon>
        <BaseControlsButtonIcon
          v-if="!hideLayoutOptions"
          @button-clicked="emit('horizontalLayout', false)"
          :tooltip-text="$t('common.tooltip.verticalLayout')"
          :active="!isHorizontalLayout">
          <IconLayoutVertical class="size-4" />
        </BaseControlsButtonIcon>
      </div>
    </div>

    <div
      v-if="mode === 'edit' && !hideSaveCancelButtons"
      class="flex items-center justify-center gap-2">
      <BaseButton @click="emit('cancel')" size="xs" outline class="gap-2 capitalize">
        {{ $t('common.actions.cancel') }}
      </BaseButton>
      <BaseButton @click="emit('save')" size="xs" class="gap-2 capitalize">
        {{ $t('common.actions.save') }}
      </BaseButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/common/BaseButton.vue';
import BaseControlsButtonIcon from '@/components/common/BaseControlsButtonIcon.vue';
import IconLayoutHorizontal from '@/assets/icons/IconLayoutHorizontal.vue';
import IconLayoutVertical from '@/assets/icons/IconLayoutVertical.vue';
import IconArrowLeft from '@/assets/icons/IconArrowLeft.vue';
import IconPencilSquare from '@/assets/icons/IconPencilSquare.vue';
import { onBeforeRouteLeave, useRouter } from 'vue-router';
import { onBeforeMount } from 'vue';

const props = defineProps<{
  title?: string;
  hideLayoutOptions?: boolean;
  hideSaveCancelButtons?: boolean;
  isHorizontalLayout?: boolean;
  linkName?: string;
  navigateToPreviousPage?: boolean;
  mode: 'view' | 'edit';
  isEditActive?: boolean;
  isModified?: boolean;
}>();
const router = useRouter();
const emit = defineEmits(['horizontalLayout', 'editMode', 'save', 'cancel']);
function onBack() {
  if (props.navigateToPreviousPage) {
    router.go(-1);
  }
  router.push({ name: props.linkName });
}

onBeforeRouteLeave(() => {
  if (props.isModified) {
    const value = window.confirm('Changes that you made may not be saved.');
    if (value) return true;
    else return false;
  }
  window.removeEventListener('beforeunload', onUnload);
});

onBeforeMount(() => {
  window.addEventListener('beforeunload', onUnload);
});

function onUnload(e: any) {
  if (props.isModified) {
    e.stopPropagation();
    e.preventDefault();
  }
}
</script>
